export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-3xl overflow-hidden relative">
          <div className="relative z-10 p-8 md:p-12 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-5 rounded-2xl bg-white/15 backdrop-blur-sm">
              <i className="ri-mail-send-line text-white text-3xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white font-heading mb-3">
              我要爆料
            </h2>
            <p className="text-white/75 text-sm md:text-base max-w-md mx-auto mb-8 leading-relaxed">
              你有独家内幕或一手猛料？欢迎匿名投稿给我们！
              你的身份将受到严格保护，审核通过后第一时间发布，与368万瓜友共享真相。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#about"
                onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white text-primary-600 font-semibold px-8 py-3.5 rounded-full text-base whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-white/90"
              >
                <i className="ri-edit-line text-lg"></i>
                立即投稿爆料
              </a>
              <span className="text-white/60 text-sm">或发送至：tips@91heiliaochigua.com</span>
            </div>
          </div>
          <div className="absolute top-0 right-0 w-64 h-64 opacity-10">
            <div className="w-full h-full rounded-full bg-white blur-3xl"></div>
          </div>
          <div className="absolute bottom-0 left-0 w-48 h-48 opacity-10">
            <div className="w-full h-full rounded-full bg-white blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}